import { useAuth } from '@/auth/useAuth';

export const useAccessToken = (): string | null => {
  const { session } = useAuth();
  return session?.tokens.accessToken ?? null;
};
